/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ITriageItemV3 } from '../getCollectionTriageNextV3/get-collection-triage-next-v3-response';
import { triageItemV3Schema } from '../getCollectionTriageNextV3/get-collection-triage-next-v3-response';

export const navigateCollectionTriageClipV3ResponseSchema = createApiResponseSchema(
  triageItemV3Schema,
) as z.ZodSchema<IAPI<ITriageItemV3 | null>>;

export type INavigateCollectionTriageClipV3Response = IAPI<ITriageItemV3 | null>;
